import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Contato } from '../../models/contato';
import { ConversaContatoPage } from '../conversa-contato/conversa-contato';
import { ContatoProvider } from '../../providers/contato/contato';
import { ContatoLocalProvider } from '../../providers/contato-local/contato-local';
import { ToastController } from 'ionic-angular';
import { FotoProvider } from '../../providers/foto/foto';

@IonicPage()
@Component({
  selector: 'page-adicionar-contato',
  templateUrl: 'adicionar-contato.html',
})
export class AdicionarContatoPage {

  private queryText: string;
  private contatos: Contato[];
  private idUsuario: number;
  private idEmpresa: number;
  public mostrarMensagem: boolean;

  constructor(private navCtrl: NavController, private navParams: NavParams, 
    private contatoProvider: ContatoProvider, private loadingController: LoadingController, 
    private contatoLocal: ContatoLocalProvider, private toastCtrl: ToastController, 
    private fotoProvider: FotoProvider) {
    this.queryText = "";
    this.idUsuario = this.navParams.get('idUsuario');
    this.idEmpresa = this.navParams.get('idEmpresa');
  }

  public fazerPesquisa(): void {
    if (!(this.queryText.trim() === "")) {
      this.buscarUsuarios();
    }
  }

  private buscarUsuarios(): void {
    this.mostrarMensagem = false;
    this.contatos = [];
    this.contatoProvider.listarContatosComNome(this.queryText, this.idEmpresa).subscribe(
      (contatos: Contato[]) => {
        if (contatos && contatos.length > 0) {
          this.contatos = contatos.filter(c => c.idUsuario !== this.idUsuario);
          if (this.contatos.length === 0) {
            this.mostrarMensagem = true;
          }
        } else {
          this.mostrarMensagem = true;
        }
      }
    );
  }

  public async adicionarContato(contato: Contato): Promise<void> {
    const contatoLocal = this.contatoLocal.getContatoComIdUsuario(contato.idUsuario);
    if (contatoLocal) {
      //contato já existe no aparelho
      this.navCtrl.popToRoot();
      //this.abrirPaginaDeConversaContato(contatoLocal);
    } else {
      const loading = this.loadingController.create({content: 'Aguarde...'});
      await loading.present();
      //contato não existe e vai ser criado
      this.contatoProvider.adicionarContato(this.idUsuario, contato.idUsuario).subscribe(
        (idContato: number) => {
          contato.idContato = idContato;
          this.contatoLocal.adicionarContato(contato);
          this.navCtrl.popToRoot();
        }, error => {
          loading.dismiss();
          this.apresentarToastErro();
        }, () => {
          loading.dismiss();
        }
      );
    }
  }

  private apresentarToastErro(): void {
    const toast = this.toastCtrl.create({
      message: 'Ocorreu um erro inesperado, por favor tente mais tarde.',
      duration: 3000
    });
    toast.present();
  }

  public getImagemUsuario(contato: Contato):string{
    if (contato.hashFoto != "") {
      return this.fotoProvider.getUrlImagemServidor(contato.hashFoto);
    }
    return 'assets/img/usuario.png';
  }

}



// WEBPACK FOOTER //
// ./src/pages/adicionar-contato/adicionar-contato.ts